import React from 'react';
import { canvasFormBannerTypes } from '../../../../../../../util/uiconstants';
import CanvasBanner from '../../../../../../Common/CanvasForm/Banner/CanvasBanner';

export default function IndependenceBanner({ document }) {
	return (
		<React.Fragment>
			<CanvasBanner documentId={document.id} bannerType={canvasFormBannerTypes.independence} />
			{document.customInstruction && (
				<CanvasBanner
					documentId={document.id}
					bannerType={canvasFormBannerTypes.independenceCustomInstructions}
					customInstruction={document.customInstruction}
				/>
			)}
		</React.Fragment>
	);
}
